import React, { Component } from "react";
import axios from "axios";
import { authService } from "../auth";
import * as _ from "lodash";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";
import {convertUnicode, nFormatter} from "../commons/CommonFunctions";
import dateUtil from "date-and-time";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ProjectDetailsCommonModal from "./ProjectDetailsCommonModal";
import FeedsUnauthItem from "../Feeds/FeedsUnauthItem";

class UnauthPageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: authService.getUserDetailsFromLocalStorage(),
      loginRequired: false,
      opportunities: [],
      unAuthCircle: [],
      unAuthPost: {},
      projectDetail: {},
      isModalOpen: false,
      projectId: undefined,
      pathName: this.props.pathName
    }
  }
  modalOpen = (slug) => {
    this.setState({ isModalOpen: true }, () => {
      this.setState({
        slug: "/project/feeds/" + slug,
      });
      this.getUnauthProjectDetails(slug);
    });
  };
  getCost = (project) => {
    let fees = "";
    if (
      (project && project.cost) ||
      project.remuneration ||
      project.renumeration
    ) {
      fees = project.cost || project.remuneration || project.renumeration;
    }
    return fees;
  };
  // for trending opportunity (Projects) starts ***********************************
  getUnauthTrendingOppurtunity = (page, size) => {
    let trendingOpportunityURL =
      process.env.REACT_APP_userServiceURL + "/unauth/trending-opportunity/";
    let url = trendingOpportunityURL + "?page=" + page + "&size=" + size;
    axios({
      method: "get",
      url: url,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.body &&
          response.data.body.content
        ) {
          this.setState({
            opportunities: response.data.body.content,
          });
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  };
  getUnAuthTrendingCircle = () => {
    let postBody = {
      page: 0,
      size: 4,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_userServiceURL + "/circle/trending-circle",
      data: postBody,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.status === "200 OK") {
          this.setState({
            unAuthCircle: response.data.body.content,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getUnAuthFeedsFetch = () => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/unauth/getNewsFeed/trending?newsFeedType=TOP&page=0&size=3",
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.status === "200 OK") {
          this.setState({
            unAuthPost: response.data.body,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getUnauthProjectDetails = (slug) => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/unauth/find-project-description-details-by-slug/" +
        slug,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response.data;
        if (res.status === "200 OK") {
          this.setState({ projectDetail: res.body }, () => {
            if (this.state.projectDetail && this.state.projectDetail.project) {
              if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.sessionTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              }
            }
          });
          window.$("#projectDetails").modal("show");
        }
      })
      .catch((err) => {
        if (err && err.response) {
          this.setState({
            notFoundstatusCode: err.response.status,
            error: { message: err.response.data.message, err: err.response },
          });
        }
        this.setState({
          isLoaded: true,
        });
      });
  };
  openModalClose = () => {
    this.setState({
      slug: "",
      isModalOpen: false,
    });
    window.$("#projectDetails").modal("hide");
  };

  loginRequired = () => {
    this.setState({ loginRequired: true});
    window.$("#loginModal").modal("show");
  };

  handleLoginClose = () => {
    this.setState({ loginRequired: false });
    window.$("#loginModal").modal("hide");
  };

  handleApply = (slug) => {
    this.setState(
      {
        pathName: slug,
        loginRequired: true,
      },
      () => {
        window.$("#loginModal").modal("show");
      }
    );
};


  componentDidMount() {
    this.getUnauthTrendingOppurtunity(0, 3);
    this.getUnAuthFeedsFetch();
    this.getUnAuthTrendingCircle();
  }
  render() {
    const utcSeconds = this.state.pollData && this.state.pollData.createTime;
    const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds / 1000);
    return (
      <>
        <div className="unAuthSummrow">
          <div className="topDesc">
            <h2 className="h2ttl">
              Trending Opportunities{" "}
              <a
                href="javascript:void(0)"
                className="link"
                onClick={() =>
                  this.setState({ loginRequired: true })
                }
              >
                View All
              </a>
            </h2>
          </div>
          <div className="explLatarticle">
            <OwlCarousel
              id={"unauthProjectcarousel"}
              autoWidth={true}
              nav={false}
              margin={12}
              items={3}
              loop={false}
              rewind={true}
            >
              {this.state.opportunities &&
                this.state.opportunities.map((data, index) => {
                  if (index < 3) {
                    return data.secondaryEntityType === "JOB" ||
                      data.secondaryEntityType ===
                      "ASSIGNMENT" ? (
                      <div className="item">
                        <div className="projectlist">
                          <div className="projectlistinn">
                            <div className="projectlisttop">
                              <div className="projheadOuter">
                                <div
                                  className="projhead"
                                  onClick={(e) =>
                                    this.modalOpen(
                                      data.project.slug
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <figure
                                    className="complogo"
                                    onClick={(e) =>
                                      this.modalOpen(
                                        data.project.slug
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={
                                        data &&
                                          data.project &&
                                          !_.isNull(
                                            data.project
                                              .coverImage
                                          ) &&
                                          !_.isUndefined(
                                            data.project
                                              .coverImage
                                          )
                                          ? data.project
                                            .coverImage
                                          : "https://cdn.dscovr.com/images/project-default.webp"
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "https://cdn.dscovr.com/images/project-default.jpg";
                                      }}
                                      alt=""
                                    />
                                  </figure>
                                  <div>
                                    <h5>
                                      {data &&
                                        unescape(
                                          data.creatorName
                                        )}
                                    </h5>
                                    {data &&
                                      data.project &&
                                      data.project.location &&
                                      data.project.location
                                        .city && (
                                        <span className="address">
                                          {data.project
                                            .location &&
                                            data.project
                                              .location.country}
                                        </span>
                                      )}
                                  </div>
                                </div>
                              </div>
                              {((data &&
                                data.project &&
                                (data.project.cost ||
                                  data.project.remuneration ||
                                  data.project.renumeration) >
                                0 &&
                                data.project.isDisclosed ===
                                false) ||
                                data.project
                                  .participationCount > 0) && (
                                  <div className="projectpricetime">
                                    {data &&
                                      this.getCost(data.project) >
                                      0 &&
                                      data.project.isDisclosed ===
                                      false && (
                                        <span className="price">
                                          {" "}
                                          {
                                            data.project.currency
                                          }{" "}
                                          {nFormatter(
                                            this.getCost(
                                              data.project
                                            ),
                                            2
                                          )}{" "}
                                          {!_.isNull(
                                            data.project
                                              .packageType
                                          ) &&
                                            !_.isUndefined(
                                              data.project
                                                .packageType
                                            ) &&
                                            data.project.packageType.toLowerCase() !==
                                            "custom" &&
                                            data.project
                                              .packageType}
                                        </span>
                                      )}
                                    {data.project
                                      .participationCount > 0 ? (
                                      <>
                                        {data.project
                                          .participationCount ===
                                          0 ||
                                          data.project
                                            .participationCount ===
                                          1 ? (
                                          <span className="perticipent">
                                            {unescape(
                                              data.project
                                                .participationCount
                                            )}{" "}
                                            Applicant
                                          </span>
                                        ) : (
                                          <span className="perticipent">
                                            {unescape(
                                              data.project
                                                .participationCount
                                            )}{" "}
                                            Applicants
                                          </span>
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                )}
                            </div>
                            <div className="projectlistmid">
                              <h4>
                                <a
                                  href="javascript:void(0)"
                                  onClick={(e) =>
                                    this.modalOpen(
                                      data.project.slug
                                    )
                                  }
                                >
                                  <span>
                                    {data &&
                                      data.project &&
                                      data.project.title &&
                                      data.project.title
                                        .split("\\n")
                                        .map((title) => (
                                          <>
                                            {convertUnicode(
                                              title
                                            )}
                                            <br />
                                          </>
                                        ))}
                                  </span>
                                  {/*{title}*/}
                                </a>
                              </h4>
                              <a
                                href="javascript:void(0)"
                                onClick={(e) =>
                                  this.modalOpen(
                                    data.project.slug
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <p
                                  style={{ cursor: "pointer" }}
                                >
                                  {data &&
                                    data.project &&
                                    data.project.shortBrief &&
                                    data.project.shortBrief
                                      .split("\\n")
                                      .map((shortBrief) => (
                                        <>
                                          {convertUnicode(
                                            shortBrief
                                          )}
                                          <br />
                                        </>
                                      ))}
                                </p>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="item">
                        <div className="projeventlist">
                          <div className="projeventlistinn">
                            <figure
                              className="eventimg"
                              href="javascript:void(0)"
                              onClick={(e) =>
                                this.modalOpen(
                                  data.project.slug
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src={
                                  data &&
                                    data.project &&
                                    !_.isNull(
                                      data.project.coverImage
                                    ) &&
                                    !_.isUndefined(
                                      data.project.coverImage
                                    )
                                    ? data.project.coverImage
                                    : "https://cdn.dscovr.com/images/project-default.webp"
                                }
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://cdn.dscovr.com/images/project-default.jpg";
                                }}
                                alt=""
                              />
                              {data &&
                                this.getCost(data.project) >
                                0 &&
                                data.project.isDisclosed ===
                                false && (
                                  <span className="price">
                                    {" "}
                                    {data.project.currency}{" "}
                                    {nFormatter(
                                      this.getCost(
                                        data.project
                                      ),
                                      2
                                    )}{" "}
                                    {!_.isNull(
                                      data.project.packageType
                                    ) &&
                                      !_.isUndefined(
                                        data.project.packageType
                                      ) &&
                                      data.project.packageType.toLowerCase() !==
                                      "custom" &&
                                      data.project.packageType}
                                  </span>
                                )}
                            </figure>
                            <div className="projeventdesc">
                              <h4>
                                <a
                                  href="javascript:void(0)"
                                  onClick={(e) =>
                                    this.modalOpen(
                                      data.project.slug
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {data &&
                                    data.project &&
                                    data.project.title &&
                                    data.project.title
                                      .split("\\n")
                                      .map((title) => (
                                        <>
                                          {convertUnicode(
                                            title
                                          )}
                                          <br />
                                        </>
                                      ))}
                                  {/*{title}*/}
                                </a>
                              </h4>
                              <div
                                className="d-flex"
                                style={{ cursor: "default" }}
                              >
                                <div className="date">
                                  {dateUtil.format(
                                    new Date(
                                      data &&
                                      data.project
                                        .beginningTime
                                    ),
                                    "DD"
                                  )}
                                  <span>
                                    {!_.isUndefined(
                                      data.project.beginningTime
                                    ) &&
                                      !_.isNull(
                                        data.project
                                          .beginningTime
                                      ) &&
                                      dateUtil
                                        .format(
                                          new Date(
                                            data &&
                                            data.project
                                              .beginningTime
                                          ),
                                          "MMM"
                                        )
                                        .toUpperCase()}
                                  </span>
                                  <span>
                                    {!_.isUndefined(
                                      data.project.beginningTime
                                    ) &&
                                      !_.isNull(
                                        data.project
                                          .beginningTime
                                      ) &&
                                      dateUtil
                                        .format(
                                          new Date(
                                            data &&
                                            data.project
                                              .beginningTime
                                          ),
                                          "YYYY"
                                        )
                                        .toUpperCase()}
                                  </span>
                                </div>
                                <div className="projeventdesctxt">
                                  <a
                                    href="javascript:void(0)"
                                    onClick={(e) =>
                                      this.modalOpen(
                                        data.project.slug
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <p>
                                      {data &&
                                        data.project &&
                                        data.project
                                          .shortBrief &&
                                        data.project.shortBrief
                                          .split("\\n")
                                          .map((shortBrief) => (
                                            <>
                                              {convertUnicode(
                                                shortBrief
                                              )}
                                              <br />
                                            </>
                                          ))}
                                    </p>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
            </OwlCarousel>
          </div>
        </div>
        <div className="unAuthSummrow">
          <div className="topDesc">
            <h2 className="h2ttl">
              Trending Community{" "}
              <a
                href="javascript:void(0)"
                className="link"
                onClick={() =>
                  this.setState({ loginRequired: true })
                }
              >
                View All
              </a>
            </h2>
          </div>
          <div className="explLatarticle">
            <OwlCarousel
              id={"unauthCirclecarousel"}
              autoWidth={true}
              nav={false}
              margin={24}
              items={3}
              loop={false}
              rewind={true}
            >
              {this.state.unAuthCircle.map((item) => {
                return (
                  <div className="item" key={item.id}>
                    <div className="CirclefrYouEachbx">
                      <a href={"/community/" + item.slug}>
                        <div className="CirclefrYouImgbx">
                          <img
                            src={
                              item.resizedCoverImages &&
                                item.resizedCoverImages.compressed
                                ? item.resizedCoverImages
                                  .compressed
                                : "https://cdn.dscovr.com/images/prof-banner.webp"
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://cdn.dscovr.com/images/prof-banner.png";
                            }}
                            alt=""
                          />
                          <figure>
                            <img
                              src={
                                item.resizedProfileImages &&
                                  item.resizedProfileImages
                                    .compressed
                                  ? item.resizedProfileImages
                                    .compressed
                                  : "https://cdn.dscovr.com/images/circleDefault.webp"
                              }
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  "https://cdn.dscovr.com/images/circleDefault.png";
                              }}
                              alt=""
                            />
                          </figure>
                        </div>
                      </a>
                      <div className="CirclefrYouDescbx">
                        <div className="circleTitleBl">
                          <h5>
                            <span>
                              <a href={"/community/" + item.slug}>
                                {item.title}
                              </a>
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </OwlCarousel>
          </div>
        </div>
        {this.state.unAuthPost && this.state.unAuthPost.content && this.state.unAuthPost.content.length > 0 &&
          <div className="unAuthSummrow">
            <div className="topDesc">
              <h2 className="h2ttl">
                Trending Feeds{" "}
                {this.state.unAuthPost && !this.state.unAuthPost?.page?.last &&
                  <a
                    href="javascript:void(0)"
                    className="link"
                    onClick={() =>
                      this.setState({ loginRequired: true })
                    }
                  >
                    View All
                  </a>
                }
              </h2>
            </div>
            <div className="explLatarticle">
              {/* <OwlCarousel
                id={"unauthFeedcarousel"}
                autoWidth={true}
                margin={12}
                items={3}
                loop={false}
                rewind={true}
              >
                {this.state.unAuthPost && this.state.unAuthPost.content && this.state.unAuthPost.content.map((item, idx) => {
                  return (
                    <div className="item" key={idx}>
                      <FeedsUnauthItem item={item} key={item.id} idx={idx} signUpRequired={this.props.signUpRequired} loginRequired={this.loginRequired} />
                    </div>
                  );
                })}
              </OwlCarousel> */}
              <div className="row">
                {this.state.unAuthPost && this.state.unAuthPost.content && this.state.unAuthPost.content.map((item, idx) => {
                  return (
                    <div className="col-md-4" key={idx}>
                      <FeedsUnauthItem item={item} key={item.id} idx={idx} signUpRequired={this.props.signUpRequired} loginRequired={this.loginRequired} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        }

        {this.state.isModalOpen === true &&
          <ProjectDetailsCommonModal projectDetail={this.state.projectDetail} openModalClose={this.openModalClose} handleApply={this.handleApply} />
        }

        <div className="bottomFloatButton">
          <a
            href="javascript:void(0)"
            onClick={this.props.signUpRequired}
            className="bkloginBtn"
          >
            <span>Join Us</span> to discover your passion for
            nature
          </a>
        </div>
        
        {this.state.loginRequired === true && (
          <AuthModalComponent
            pathname={this.state.pathName}
            history={this.props.history}
            handleLoginClose={this.handleLoginClose}
          />
        )}
      </>
    )
  }
}
export default UnauthPageItem;